export class NewOrUsed {
    checkNewOrUsed: string="N";
    search:boolean;
}